import request from './http';


/**
 * 相关知识库推荐
 * @param {*} data 
 * @returns 
 */
export const recommendfolderpage = (data) => {
    return request({
        url: '/knowlegebase/recommendfolderpage',
        method: 'post',
        data: data
    })
}

/**
 * 根据知识库id查询相关文献检索
 * @param {*} data 
 * @returns 
 */
export const searchlistByFolderId = (query) => {
    return request({
        url: '/knowlegebase/searchlist',
        method: 'post',
        params: query
    })
}

/**获取同机构共享知识库及自己知识库列表 */
export const sameinstitionsharelist = () => {
    return request({
        url: '/knowlegebase/sameinstitionsharelist',
        method: 'get'
    })
}

/**获取自己知识库列表 */
export const folderlist = () => {
    return request({
        url: '/knowlegebase/folderlist',
        method: 'get'
    })
}

/**添加知识库 */
export const addfolder = (data) => {
    return request({
        url: '/knowlegebase/addfolder',
        method: 'post',
        data:data
    })
}
/**修改知识库 */
export const updateFolder = (data) => {
    return request({
        url: '/knowlegebase/updateFolder',
        method: 'post',
        data:data
    })
}
/**删除知识库 */
export const deletefolder = (query) => {
    return request({
        url: '/knowlegebase/deletefolder',
        method: 'get',
        params: query
    })
}

/**添加知识库文章 (多对多)*/
export const addfoldersarticles = (data) => {
    return request({
        url: '/knowlegebase/addfoldersarticles',
        method: 'post',
        data:data
    })
}

/** 添加/修改知识库文章(一对多)*/
export const addorupdatefolderarticles = (data) => {
    return request({
        url: '/knowlegebase/addorupdatefolderarticles',
        method: 'post',
        data:data
    })
}
/**根据知识库id获取文章ids */
export const getarticleIds=(query)=>{
    return request({
        url: '/knowlegebase/articleIdsByFolderId',
        method: 'get',
        params: query
    })
}

/**根据文章id获取对应的知识库ids */
export const getfolderIds=(query)=>{
    return request({
        url: '/knowlegebase/folderIds',
        method: 'get',
        params: query
    })
}
/**移除分组 */
export const deletefolderarticle=(query)=>{
    return request({
        url: '/knowlegebase/deletefolderarticle',
        method: 'get',
        params: query
    })
}
/**检索规则 */
export const searchListByRule=(query)=>{
    return request({
        url: '/knowlegebase/searchListByRule',
        method: 'get',
        params: query
    })
}

/**获取文章详情 */
export const getDetail=(query)=>{
    return request({
        url: '/knowlegebase/getDetail',
        method: 'get',
        params: query
    })
}
/**获取当前文章笔记用户信息 */
export const getUsersNotes=(query)=>{
    return request({
        url: '/knowlegebase/getUsersNotes',
        method: 'get',
        params: query
    })
}

/** 获取当前文章当前用户同机构下做的笔记记录（批注+心得+标记） */
export const notetaggingpages=(data)=>{
    return request({
        url: '/knowlegebase/notetaggingpages',
        method: 'post',
        data: data
    })
}

/**添加笔记(批注，标记，心得) */
export const addexcerpts=(data)=>{
    return request({
        url: '/knowlegebase/addexcerpts',
        method: 'post',
        data: data
    })
}
/**修改(批注，标记，心得) */
export const modexcerpts=(data)=>{
    return request({
        url: '/knowlegebase/modexcerpts',
        method: 'post',
        data: data
    })
}
/**删除(批注，标记，心得) */
export const delexcerpts=(query)=>{
    return request({
        url: '/knowlegebase/delexcerpts',
        method: 'get',
        params: query
    })
}   
/**关联政策(引用) */
export const getQuote=(query)=>{
    return request({
        url: '/knowlegebase/getQuote',
        method: 'get',
        params: query
    })
}
/**添加修改笔记 */
export const addOrUpdateArticleNote=(data)=>{
    return request({
        url: '/knowlegebase/addOrUpdateArticleNote',
        method: 'post',
        data: data
    })
}
/***获取同机构下用户做笔记的文章列表数据去重 */
export const sameinstitionnotequerypage=(data)=>{
    return request({
        url: '/knowlegebase/sameinstitionnotequerypage',
        method: 'post',
        data: data
    })
}
/**删除笔记 */
export const deleteNoteByArticleId=(query)=>{
    return request({
        url: '/knowlegebase/deletenotebyarticleid',
        method: 'get',
        params: query
    })
}

/***关连政策下级政策 */
export const getcitedbydata=(query)=>{
    return request({
        url: '/knowlegebase/getcitedbydata',
        method: 'get',
        params: query
    })
}

/**获取当前文章笔记数量 */
export const getNoteCountByArticleId=(query)=>{
    return request({
        url: '/knowlegebase/getNoteCountByArticleId',
        method: 'get',
        params: query
    })
}

/***政策关联图 */
export const analysisgraph=(data)=>{
    return request({
        url: '/Analysis/RenderHtmlGrapm',
        method: 'post',
        data: data
    })
}
/**相似接口 */
export const getsimilarbydata=(query)=>{
    return request({
        url: '/knowlegebase/getsimilarbydata',
        method: 'get',
        params: query
    })
}